import React, { useState, useContext } from "react";
import { Select, Option } from "@carvana/showroom-forms/Select";
import { AnalyticsContext } from "@carvana/eventable-clickstream";
import { Wrapper } from "./Dropdown.styles";
import { RegistrationAnalytics } from "../../../constants";

type OwnProps = {
  title?: string;
  list?: { id: number; value: string; selected: boolean }[];
  resetThenSet?: (id: number) => void;
  onSelect?: (value: string) => void;
};

const Dropdown = ({
    list,
    resetThenSet = () => {},
    onSelect = () => {}
}: OwnProps) => {
  const [selectedValue, setSelectedValue] = useState<string>(list?.find(item => item.selected)?.value || '');
  const { trackEvent } = useContext(AnalyticsContext) as any;

  const handleOnChange = (e: any) => {
    const { value } = e.target;
    trackEvent(RegistrationAnalytics.DOCUMENT_SELECTED, value);
    setSelectedValue(value);
    resetThenSet(list?.find(item => item.value === value)?.id || 0);
    onSelect(value);
  }

  const handleDropdownOpen = () => {
    trackEvent(RegistrationAnalytics.DROPDOWN_EXPANDED);
  }

  return (
    <Wrapper>
      <Select
        id="reg-doc-select"
        value={selectedValue}
        onChange={handleOnChange}
        label="Document Type"
        onOpen={handleDropdownOpen}
      >
        {(list || []).map(item => (
            <Option
              className="dd-list-item"
              key={item.id}
              value={item.value}
            >
              {item.value}
            </Option>
          ))}
      </Select>
    </Wrapper>
  );
}

export default Dropdown;
